import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW1319InputVO } from "../vo/kymw1319-inputVO.model";
import { Injectable } from "@angular/core";
import { KYMW1319Model } from "../kymw1319.model";

export type getFeatureThemaListForUpdateResponce = {
  FeatureInfoList: {
    FeatureCode: string,
    FeatureName: string,
  }[]
}

/**
 * 特集情報取得
 *
 * @export GetFeatureThemaListForUpdateService
 * @class GetFeatureThemaListForUpdateService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetFeatureThemaListForUpdateService extends PlessJsonResponderSub<getFeatureThemaListForUpdateResponce> {
  vo: KYMW1319InputVO;
  model: KYMW1319Model;
  successFunc: Function;

  /**
   * bodyにセットする値を返す
   * 
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetFeatureThemaListForUpdateService
   */
  getBody() {
    return new PlessRequest({
      search: {
        FeatureInfoList: {
          condition: {
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType,
            StartOrderCode: this.model.startOrderCode,
            BundleCatalogFlag: this.vo.bundleCatalogFlag,
          }
        }
      }
    })
  }

  /**
   * API呼び出し
   * 
   * @param model 
   * @param successFunc 
   * @memberof GetFeatureThemaListForUpdateService
   */
  execute(vo: KYMW1319InputVO, model: KYMW1319Model, successFunc: Function = null) {
    this.vo = vo;
    this.model = model;
    this.successFunc = successFunc;
    this.send('getFeatureThemaListForUpdate', this.getBody());
  }

  /**
   * API通信成功時の処理
   * 
   * @param data 
   * @memberof GetFeatureThemaListForUpdateService
   */
  success(data: getFeatureThemaListForUpdateResponce): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}